import {RFValue} from 'react-native-responsive-fontsize';
import Feather from 'react-native-vector-icons/Feather';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
`;

export const ModalCard = styled.View`
  background-color: ${({theme}) => theme.colors.background};
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(20)}px ${RFValue(20)}px 0 ${RFValue(20)}px;
  overflow: hidden;
`;

export const Header = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(18)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const Subtitle = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-size: ${RFValue(10)}px;
  font-family: ${({theme}) => theme.fonts.regular};
  line-height: ${RFValue(14)}px;
`;

export const Banner = styled.Image`
  width: 100%;
  height: ${RFValue(73)}px;
  margin: ${RFValue(4)}px 0;
`;

export const CloseButton = styled.TouchableOpacity`
  width: ${RFValue(32)}px;
  height: ${RFValue(32)}px;
  border-radius: ${RFValue(16)}px;
  background-color: ${({theme}) => theme.colors.border3};
  align-items: center;
  justify-content: center;
`;

export const CloseIcon = styled(Feather)`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(18)}px;
`;

export const StepHeader = styled.View`
  margin-top: ${RFValue(16)}px;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const StepItem = styled.View`
  flex-direction: row;
  align-items: center;
`;

export const StepCircle = styled.View<{active: boolean}>`
  width: ${RFValue(28)}px;
  height: ${RFValue(28)}px;
  border-radius: ${RFValue(14)}px;
  align-items: center;
  justify-content: center;
  background-color: ${({theme, active}) =>
    active ? theme.colors.primary_light : theme.colors.border3};
  border-width: 1px;
  border-color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.border};
`;

export const StepNumber = styled.Text<{active: boolean}>`
  color: ${({theme, active}) =>
    active ? theme.colors.primary : theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.bold};
  font-size: ${RFValue(12)}px;
`;

export const StepLabel = styled.Text<{active: boolean}>`
  margin-left: ${RFValue(8)}px;
  color: ${({theme, active}) =>
    active ? theme.colors.text_dark : theme.colors.text};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
`;

export const StepDivider = styled.View`
  flex: 1;
  height: 1px;
  margin: 0 ${RFValue(10)}px;
  background-color: ${({theme}) => theme.colors.border};
`;

export const FormSpacing = styled.View`
  margin-top: ${RFValue(16)}px;
  min-height: ${RFValue(160)}px;
  padding-bottom: ${RFValue(12)}px;
  position: relative;
`;

export const ErrorMessage = styled.Text`
  margin-top: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.attention};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.medium};
  text-align: left;
`;

export const CouponLink = styled.TouchableOpacity`
  margin-top: ${RFValue(8)}px;
`;

export const CouponLinkText = styled.Text`
  color: ${({theme}) => theme.colors.text_dark};
  font-weight: 600;
  text-decoration-line: underline;
  text-align: center;
  font-size: ${RFValue(10)}px;
`;
